import { ChevronDown } from 'lucide-react';

const COULEURS = {
    blue:   'bg-blue-50 border-blue-200 text-blue-600',
    violet: 'bg-violet-50 border-violet-200 text-violet-600',
    slate:  'bg-slate-50 border-slate-200 text-slate-600',
};

/**
 * Section repliable de la page d'un attendu (exerciseurs TanoEd, groupes de
 * questions du collège) : en-tête = pill (icône + titre + compteur) + chevron,
 * corps rendu SEULEMENT quand la section est ouverte — les cartes exerciseur
 * génèrent une instance au montage, on ne les monte pas repliées.
 *
 * `action` : nœud optionnel rendu à DROITE de l'en-tête, hors du bouton de
 * pli (jamais un bouton dans un bouton) — ex. « Composer N questions ».
 */
const SectionPliable = ({ titre, icone = null, compteur = null, couleur = 'slate', ouvert, onToggle, children, className = '', action = null }) => (
    <div className={className}>
        <div className="flex items-center justify-between gap-3 mb-3">
            <button
                type="button"
                onClick={onToggle}
                aria-expanded={ouvert}
                className="flex items-center gap-2 group"
            >
                <span className={`inline-flex items-center gap-1.5 border rounded-full px-2.5 py-1 text-xs font-semibold ${COULEURS[couleur] || COULEURS.slate}`}>
                    {icone}
                    {titre}
                    {compteur != null ? ` · ${compteur}` : ''}
                </span>
                <ChevronDown
                    size={14}
                    className={`text-gray-400 group-hover:text-gray-600 transition-transform ${ouvert ? '' : '-rotate-90'}`}
                />
            </button>
            {action}
        </div>
        {ouvert ? children : null}
    </div>
);

export default SectionPliable;
